// @flow
import React, { Component } from 'react'
import _ from 'lodash'
import styled, { type StyledComponent } from 'styled-components'
import type { VkEventGroup, OptionType } from '../../types'
import { linkColor } from '../../controls/colors'
import HintWrapper from '../../controls/HintWrapper'

const ListWrapper: StyledComponent<Object, any, any> = styled.div`
  padding: 10px 0;
  display: flex;
  flex-wrap: wrap;
  width: 480px;
  margin-left: -5px;
`
const ListItem: StyledComponent<Object, any, any> = styled.div`
  display: flex;
  font-size: 14px;
  white-space: nowrap;
  padding: 2px 0 2px 5px;
`
const GroupRemoveLink: StyledComponent<Object, any, any> = styled.div`
  color: ${linkColor};
  text-decoration: none;
  padding-left: 5px;
  cursor: pointer;
`
type Props = {|
  vkEventGroups: Array<VkEventGroup>,
  vkEventOptions: Array<OptionType>,
  onClick: Function
|}

const t = {
  promopost_view: 'Просмотр промопоста',
  link_visit: 'Переход по ссылке или в сообщество',
  group_visit: 'Переход в сообщество',
  group_join: 'Подписка на сообщество',
  group_leave: 'Отписка от новостей сообщества',
  hide: 'Скрытие или жалоба',
  like: 'Лайк',
  repost: 'Репост',
  all_positive: 'Все позитивные',
  all_negative: 'Все негативные'
}

export default class VkEventGroupsList extends Component<Props> {
  render() {
    const { vkEventGroups } = this.props
    return (
      <ListWrapper>
        {_.map(vkEventGroups, (eventGroup, index: number) => {
          return [index !== 0 && ', ', this.renderListItem(eventGroup, index)]
        })}
      </ListWrapper>
    )
  }

  renderListItem(eventGroup: VkEventGroup, index: number) {
    const { sourceName, eventTypes } = eventGroup
    return (
      <ListItem key={index} className="t-VkEventGroupListItem">
        <HintWrapper triggerText={sourceName} popupText={this.eventTypesString(eventTypes)} />
        <GroupRemoveLink onClick={() => this.props.onClick(eventGroup)}>[x]</GroupRemoveLink>
      </ListItem>
    )
  }

  eventTypesString(eventTypes: Array<number>): string {
    const { vkEventOptions } = this.props
    return _.join(
      _.map(eventTypes, (eventType) => {
        const eventTypeOption = _.find(vkEventOptions, (option) => {
          return option.id === eventType
        })
        return eventTypeOption && t[eventTypeOption.name]
      }),
      ', '
    )
  }
}
